<template>
  <el-form
    ref="form"
    :model="info"
    label-position="left"
    style="width: 80%"
    @submit.native.prevent
  >
    <el-form-item
      prop="duration"
      v-if="info.isEnableCalendar == 0"
    >
      <el-input-number
        size="medium"
        v-model="duration_value"
        :controls="true"
        :min="0"
        :step-strictly="true"
        :step="0.5"
        :precision="1"
        @change="updateDetectionTotal()"
        @blur="updateDetectionTotal()"
        placeholder="请输入时长"
      ></el-input-number
      >&nbsp;h
      <!-- <div class="tipsWord">{{ timeTips }}</div> -->
    </el-form-item>
    <el-form-item
      prop="appointmentStartDate"
      :rules="[
        { required: true, trigger: 'blur', message: '请选择预约时间段' },
      ]"
      v-if="info.isEnableCalendar == 1"
    >
      <div class="calendarBox" @click="selectAppointTime">
        <span
          v-if="info.appointmentStartDate && info.appointmentStartDate != ''"
          >{{ info.appointmentStartDate }}~{{ info.appointmentEndDate }}</span
        >
        <span v-else style="color: #999">请选择预约时间段</span>
        <span class="calendarIcon">
          <i class="el-icon-date"></i>
        </span>
      </div>
      <!-- <div class="tipsWord">{{ timeTips }}</div> -->
    </el-form-item>
	<calendar v-if="calendarVisible" ref="calendar" @getTime="getTime"></calendar>
  </el-form>
</template>

<script>
import calendar from "../calendar/index.vue"
export default {
  components: {
    calendar,
  },
  props: ["info","index"],
  data() {
    return {
    duration_value: 0,
		calendarVisible: false,
		timeTips: "每半小时为预约节点，1h起约，最后测试费用根据实际时长折算收费，多退少补！根据测试要求和样品情况，平均1小时拍4个样品左右，请务必预约充足的测试时间，合理安排测试内容，尽量做到到点就结束测试。",
	};
  },
  watch: {
    info: {
      handler(newValue) {
        this.duration_value = newValue.fieIdValue
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
	selectAppointTime() {
      this.calendarVisible = true;
      this.$nextTick(() => {
        this.$refs.calendar.init(this.dataForm);
      });
    },
	getTime(form) {
        this.info = {
          ...this.info,
          ...form,
          appointmentStartDate: form.appointDate + ' ' + form.appointStartTime,
          appointmentEndDate: form.appointDate + ' ' + form.appointEndTime
        }
        //为了选时间后更新费用(计算方式根据预约时间)
		    this.$emit('updateRange',this.info)
        // this.updateDetectionTotal(this.appointForm);
    },
    updateDetectionTotal(){
      const data = {
        ...this.info,
        index: this.index,
        duration: this.duration_value,
      }
      //为了选时间后更新费用(计算方式根据预约时间)
		  this.$emit('updateRange',data)
    },
    changeStartTime(e) {
      this.info.appointmentStartDate =
        this.$dayjs(e).format("YYYY-MM-DD HH:mm");
      this.$emit("updateRange", this.info);
    },
    changeEndTime(e) {
      this.info.appointmentEndDate = this.$dayjs(e).format("YYYY-MM-DD HH:mm");
      this.$emit("updateRange", this.info);
    },
  },
};
</script>

<style lang="scss">
.calendarBox {
  position: relative;
  cursor: pointer;
  width: 300px;
  border: 1px solid #dcdfe6;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  color: #666;
  padding-left: 7px;
}
.calendarIcon {
  position: absolute;
  right: 10px;
  font-size: 20px;
}

</style>